var map = {
	"./1f78b4.png": 85300,
	"./3288bd.png": 92413,
	"./33a02c.png": 77590,
	"./80b1d3.png": 65268,
	"./8dd3c7.png": 58998,
	"./99d594.png": 4278,
	"./a6cee3.png": 39675,
	"./b2df8a.png": 87233,
	"./b3de69.png": 16769,
	"./bc80bd.png": 49239,
	"./bebada.png": 43735,
	"./cab2d6.png": 10508,
	"./d53e4f.png": 37919,
	"./e31a1c.png": 18753,
	"./e6f598.png": 81166,
	"./fb8072.png": 93530,
	"./fb9a99.png": 92211,
	"./fc8d59.png": 55505,
	"./fccde5.png": 49439,
	"./fdb462.png": 41610,
	"./fdbf6f.png": 59716,
	"./fee08b.png": 93181,
	"./ff7f00.png": 40429,
	"./ffffb3.png": 85833,
	"images/colors/1f78b4.png": 85300,
	"images/colors/3288bd.png": 92413,
	"images/colors/33a02c.png": 77590,
	"images/colors/80b1d3.png": 65268,
	"images/colors/8dd3c7.png": 58998,
	"images/colors/99d594.png": 4278,
	"images/colors/a6cee3.png": 39675,
	"images/colors/b2df8a.png": 87233,
	"images/colors/b3de69.png": 16769,
	"images/colors/bc80bd.png": 49239,
	"images/colors/bebada.png": 43735,
	"images/colors/cab2d6.png": 10508,
	"images/colors/d53e4f.png": 37919,
	"images/colors/e31a1c.png": 18753,
	"images/colors/e6f598.png": 81166,
	"images/colors/fb8072.png": 93530,
	"images/colors/fb9a99.png": 92211,
	"images/colors/fc8d59.png": 55505,
	"images/colors/fccde5.png": 49439,
	"images/colors/fdb462.png": 41610,
	"images/colors/fdbf6f.png": 59716,
	"images/colors/fee08b.png": 93181,
	"images/colors/ff7f00.png": 40429,
	"images/colors/ffffb3.png": 85833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43089;